/** Resolve API proxy paths to an absolute URL for cross-origin-safe tab navigation. */
export function resolveOnuWebAdminUrl(url: string, origin = window.location.origin): string {
  const trimmed = String(url || "").trim()
  if (!trimmed) {
    throw new Error("ONU Web Admin URL is missing")
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed
  }
  const path = trimmed.startsWith("/") ? trimmed : `/${trimmed}`
  return new URL(path, origin).href
}

/**
 * Open ONU Web Admin in a new tab after an async link fetch.
 * Opens about:blank synchronously (popup-safe), then navigates with an absolute URL.
 * Do not pass noopener on the initial open — Chrome returns null and the tab stays blank.
 */
export async function openOnuWebAdminLink(
  fetchLink: () => Promise<{ url: string; mgmt_ip: string }>,
): Promise<{ mgmt_ip: string }> {
  const tab = window.open("about:blank", "_blank")
  if (!tab) {
    throw new Error("Popup blocked. Allow popups for this site and try again.")
  }

  try {
    const link = await fetchLink()
    tab.location.href = resolveOnuWebAdminUrl(link.url)
    tab.opener = null
    return { mgmt_ip: link.mgmt_ip }
  } catch (error) {
    tab.close()
    throw error
  }
}
